import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth.js";
import { useFlushOnReconnect } from "@/features/offline-sync/hooks/useFlushOnReconnect.js";

/**
 * Protege rutas: si no hay sesión, redirige a /login.
 *
 * S2: mounts useFlushOnReconnect here so the flush hook is alive for the entire
 * authenticated session and survives route changes — a single registration point.
 */
export function AuthGuard() {
  const { isAuthenticated } = useAuth();
  // Always call the hook (Rules of Hooks); it no-ops until authenticated renders <Outlet />.
  useFlushOnReconnect();
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
